import * as React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Paper, InputBase, IconButton } from "@mui/material";

export default function Search({ handleSearchDebounce, setPage }) {
  const handleChange = (e) => {
    setPage(1);
    handleSearchDebounce(e.target.value);
  };

  const preventSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <Paper
      component="form"
      onSubmit={preventSubmit}
      elevation={0}
      sx={{
        p: "15px 18px",
        display: "flex",
        alignItems: "center",
        width: "inherit",
        height: "50px",
        borderRadius: "10px",
        justifyContent: "space-between",
      }}
    >
      <InputBase
        fullWidth
        placeholder="Search"
        onChange={handleChange}
        sx={{
          "&::placeholder": {
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "20px",
            color: "#000000",
            mixBlendMode: "normal",
            opacity: 0.4,
          },
        }}
      />
      <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
        <SearchIcon sx={{ color: "#231F20" }} />
      </IconButton>
    </Paper>
  );
}
